export default __webpack_public_path__ + "static/media/Error_Optimal.67fb2a46.svg";